import {useState, useEffect} from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Transactions from "layouts/retailerTransactions/components/Transactions";
import {getTransactions} from "api/transactions/getTransaction"
import { useTokenContext } from 'App';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import DateTimePickerViews from 'components/DateTimePicker/DateTimePickerViews'

import NotificationItem from "examples/Items/NotificationItem";
import Menu from "@mui/material/Menu";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

function RetailerTransactions() {
  const [transactions, setTransactions] = useState(null)
  const {token} = useTokenContext();
  const [openMenu, setOpenMenu] = useState(false);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);


  const doGetTransactions = async () => {
    try {

      let transactionsPromise = await getTransactions(token);
      setTransactions(transactionsPromise)

    } catch (error) {
      console.error("Error on get transactions: ", error);
    }
  }
  useEffect(() => {
    doGetTransactions();
  }, []);


  // Render the notifications menu
  const renderMenu = (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<CheckBoxIcon/>}  title="Product interest bonus" />
      <NotificationItem icon={<CheckBoxIcon/>} title="Success negotiating bonus" />
      <NotificationItem icon={<CheckBoxIcon/>} title="Discount charge" />
      <NotificationItem icon={<CheckBoxIcon/>}  title="Failed negotiating bonus" />
    </Menu>
  );

  return (
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={2}>
        <MDBox mb={3} >
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <MDButton onClick={handleOpenMenu}>
                  <MDBox display="flex" alignItems="center" p={1.8}>
                    <Icon>filter_alt</Icon>
                    <MDTypography variant="button" fontWeight="regular">
                      &nbsp;Filter by transaction type
                    </MDTypography>
                  </MDBox>
                </MDButton>
                <MDButton style={{marginLeft:"1rem"}}>
                  <MDBox display="flex" alignItems="center">
                    <DateTimePickerViews label="Filter by start date" />
                  </MDBox>
                </MDButton>
                <MDButton  style={{marginLeft:"1rem"}}>
                  <MDBox display="flex" alignItems="center">
                    <DateTimePickerViews label="Filter by end date" />
                  </MDBox>
                </MDButton>
              </Grid>
              <Grid item xs={12} md={12}>
              {transactions && 
              <Transactions transactions={transactions}/>
              }
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
    {renderMenu}
    </>
  );
}

export default RetailerTransactions;
